<div
    class="flex min-h-48 w-full items-center justify-center rounded-3xl bg-surface-B typo-sm transition-all focus-within:ring-2 focus-within:ring-border-focus"
    [class]="hasLeadingAction() ? 'py-4 pr-20 pl-8' : 'px-20 py-8'"
>
    <ng-content />
    <textarea
        #textArea
        autocomplete="off"
        class="w-full resize-none bg-transparent align-middle focus:outline-hidden"
        interactaHocus
        type="text"
        [attr.maxlength]="maxLength()"
        [attr.rows]="MIN_INPUT_ROWS"
        [formControl]="control()"
        [placeholder]="'AI.INPUT_PLACEHOLDER' | translate"
        [style.max-height.lh]="MAX_INPUT_ROWS"
        [style.min-height.lh]="MIN_INPUT_ROWS"
        (enterFocus)="refreshHeight()"
        (input)="refreshHeight()"
        (keydown.enter)="onEnterPressed($event)"
    ></textarea>
</div>
